// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import MyLoadable from 'react-loadable'
import { Loading } from '../Loading'

export const Loadable = (props = {}) => {
  return MyLoadable({
    loading: Loading,
    ...props,
  })
}
